import { render, staticRenderFns } from "./make-order.vue?vue&type=template&id=545b8a44&scoped=true&"
import script from "./make-order.vue?vue&type=script&lang=js&"
export * from "./make-order.vue?vue&type=script&lang=js&"
import style0 from "./make-order.vue?vue&type=style&index=0&id=545b8a44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "545b8a44",
  null
  
)

export default component.exports